import { useEffect } from 'react';
import { parse } from 'search-params';
import { useLocation } from 'react-router-dom';
import { useLocalStorage } from './useLocalStorage';

const useImpersonatedAsQueryStrings = () => {
  const { search } = useLocation();
  const [impersonatedAs, seImpersonatedAs, clearImpersonatedAs] = useLocalStorage(
    'impersonated-as',
    ''
  );

  useEffect(() => {
    const paramsObj = parse(search);

    if (paramsObj) {
      const impersonatedAs = paramsObj.impersonated_as;

      if (impersonatedAs) {
        seImpersonatedAs(decodeURIComponent(impersonatedAs));
        window.location.href = '/';
      }
    }
  }, [search]);

  return {
    impersonatedAs,
    seImpersonatedAs,
    clearImpersonatedAs
  };
};

export default useImpersonatedAsQueryStrings;
